import { TypeQualificationLibelle } from '@/features/domaine/types/opco/Demande/PROA/TypeQualification'
import { objectToDropdownItems } from '@/features/interface/shared/tools'

export const typeQualificationItems = objectToDropdownItems(TypeQualificationLibelle)
